module.exports = __webpack_public_path__ + "static/media/i.53ac8f93.png";